import axios from 'axios';

export function getCargoByNameOrType({
    name = undefined, type = undefined,
}) {
    return axios({
        method: 'POST',
        url: '/api/v1/cargo/find',
        withCredentials: true,
        data: {
            name,
            type,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

/**
 * @param {string[]} names 
 */
export async function getCargoNamesMatches(names = []) {
    return axios({
        method: 'POST',
        url: '/api/v2/names-matcher/cargo-names',
        withCredentials: true,
        data: {
            names,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/cargoes/names.js